import React, { useState, useEffect } from 'react'
import msg from '../Tools/MsgUtils';
import { ReactSession } from "react-client-session";

const server = process.env.REACT_APP_SERVER;
function ResetServidor(props) {
    const { regional } = props;
    const [listaSucursal, setListaSucursal] = useState([]);
    const [listaColaboradores, setListaColaboradores] = useState([]);
    const [sucursal, setSucursal] = useState('');
    const [sendAll, setSendAll] = useState(false);
    const [actualizar, setActualizar] = useState(0);
    const [vistaEnviados, setVistaEnviados] = useState(0);
    const resetarServidor = (e) => {
        let ipServer;
        if (sucursal !== '') {
            listaSucursal.map((item) => {
                var id = item.ID_SUCURSAL;
                if (id.toString() === sucursal) {
                    ipServer = item.IP_SERVIDOR;
                }
            });
            if (ipServer !== null) {
                fetch(`${server}/moduloSistemas/resetServer`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ipServidor: ipServer
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data);
                        if (data.message === 'OK') {
                            msg.msgCorrecto("Sucursal reiniciado !!!");
                        } else {
                            msg.msgError(data.message)
                        }
                    })
                    .catch(error => msg.msgError(error));
            } else {
                msg.msgError("Esta Sucursal no tiene direccion IP del servidor !!!!");
            }
        } else {
            msg.msgError("Seleccione sucursal por favor !!!!");
        }
    };
    const enviarCorreos = () => {
        fetch(`${server}/moduloSistemas/sendEmail`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ regional })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.ok) {
                    setActualizar(actualizar - 1);
                    msg.msgCorrecto(data.ok);
                } else {
                    msg.msgError(data)
                }
            })
            .catch(error => msg.msgError(error));
    }
    function buscarColaborador() {
        var input, filter, table, tr, td, i, txtValue;
        input = document.getElementById("example-search-input");
        filter = input.value.toUpperCase();
        table = document.getElementById("tablaColaboradores");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("td")[0];
            if (td) {
                txtValue = td.textContent || td.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }
    }
    const enviarCorreo = (e) => {
        var id = e.target.id;
        console.log(id);
        fetch(`${server}/moduloSistemas/sendOneEmail`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ regional, id })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.ok) {
                    setActualizar(actualizar + 1);
                    msg.msgCorrecto(data.ok);
                } else {
                    msg.msgError(data)
                }
            })
            .catch(error => msg.msgError(error));
    }
    const mostrarEnviados = () => {
        setVistaEnviados(1);
        setActualizar(actualizar+1);
    }
    const mostrarNoEnviados = ()=>{
        setVistaEnviados(0);
        setActualizar(actualizar-1);
    }
    useEffect(() => {
        if (vistaEnviados === 0) {
            fetch(`${server}/moduloSistemas/sucursales`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: ReactSession.get("regional")
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        msg.msgError(data.error);
                    } else if (data.ok) {
                        console.log(data);
                        setListaSucursal(data.ok.sucursales);
                        setListaColaboradores(data.ok.colaboradores);
                    }
                })
                .catch(err => console.log(err));
        } else {
            fetch(`${server}/moduloSistemas/sucursales/enviados`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: ReactSession.get("regional")
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        msg.msgError(data.error);
                    } else if (data.ok) {
                        console.log(data);
                        setListaSucursal(data.ok.sucursales);
                        setListaColaboradores(data.ok.colaboradores);
                    }
                })
                .catch(err => console.log(err));
        }

    }, [regional, actualizar]);
    return (
        <div className='container-fluid py-2'>
            <div className='card bg-secondary'>
                <div className="card-header text-white text-uppercase text-center">
                    <i className="fa-solid fa-server"></i> Reseteo de Servidores
                </div>
                <div className='card-body bg-gradient'>
                    <div className="forms-inputs mb-4">
                        <span className='text-white'>Sucursal</span>
                        <select className="form-select btn btn-primary" value={sucursal} onChange={(e) => setSucursal(e.target.value)}>
                            <option value=''>--ninguno--</option>
                            {listaSucursal.map((item, i) => {
                                return <option value={item.ID_SUCURSAL} key={item.ID_SUCURSAL}>{item.SUCURSAL}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="card-footer text-muted">
                    <button className='btn btn-primary'
                        onClick={resetarServidor}
                    ><i className="bi bi-pc-display px-2"></i>Reset Server</button>
                </div>
            </div>
            <div className='py-2'>
                <div className='card bg-secondary py-2'>
                    <div className="card-header text-white text-uppercase text-center">
                        <i className="fa-solid fa-key"></i> Reseteo de Contraseña <b>GiftCard</b>
                    </div>
                    <div className='card-body bg-gradient'>
                        <ul className="nav justify-content-center">
                            <li className={vistaEnviados === 0 ? "nav-item selected bg-gradient" : "nav-item bg-gradient"} >
                                <a className="nav-link active text-light" onClick={mostrarNoEnviados}><i className="fa-solid fa-at"></i> No Enviados</a>
                            </li>
                            <li className={vistaEnviados === 1 ? "nav-item selected bg-gradient" : "nav-item bg-gradient"} >
                                <a className="nav-link active text-light" onClick={mostrarEnviados}><i className="fa-solid fa-envelope-circle-check"></i> Enviados</a>
                            </li>
                        </ul>
                        <div className="forms-inputs mb-4 text-center text-white">
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={!sendAll} onChange={() => setSendAll(false)} />
                                <label className="form-check-label" >
                                    Todos Colaboradores
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked={sendAll} onChange={() => setSendAll(true)} />
                                <label className="form-check-label" >
                                    Escoger Colaborador
                                </label>
                            </div>
                        </div>
                        <div className='overflow-auto config-overflow table-responsive bg-white'>
                            <table id='tablaColaboradores' className="table table-striped ">
                                <thead className='text-center bg-dark text-white'>
                                    <tr>
                                        <th scope="col">NOMBRE</th>
                                        <th scope="col">CORREO</th>
                                        <th scope="col">ESTADO</th>
                                        <th scope="col">ACCIÓN</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listaColaboradores.map((item) => {
                                        return (
                                            <tr key={item.ID_CLIENTE}>
                                                <td>{item.COLABORADOR}</td>
                                                <td>{item.EMAIL}</td>
                                                <td>{item.EMAILI ? "Enviado" : "No se envió correo"}</td>
                                                <td><button id={item.ID_CLIENTE} className='btn btn-success' onClick={enviarCorreo}>
                                                    <i id={item.ID_CLIENTE} className="fa-solid fa-envelopes-bulk"></i>Enviar
                                                </button></td>
                                            </tr>)
                                    })}
                                </tbody>
                            </table>
                        </div>
                        {sendAll === true
                            ? <div>
                                <div className="col-md-6 mx-auto">
                                    <div className="small fw-light text-white">Buscar Colaborador</div>
                                    <div className="input-group">
                                        <input className="form-control border-end-0 border rounded-pill"
                                            type="text"
                                            id="example-search-input"
                                            onChange={() => buscarColaborador()} />
                                        <span className="input-group-append">
                                            <a className="btn btn-outline-ligth bg-secondary border-bottom-0 border rounded-pill ms-n5" type="button">
                                                <i className="fa fa-search"></i>
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            : <></>}
                    </div>
                    <div className={vistaEnviados===0?"card-footer text-muted":"d-none"}>
                        <button className='btn btn-info' onClick={enviarCorreos}><i className="fa-solid fa-envelopes-bulk"></i> Enviar a Todos</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetServidor
